import React from 'react';
import styled from 'styled-components';
import { calc4k } from '../utilities';
import { colors, gradient, padding } from '../GlobalStyle';

export default function( { image, title, desc, note, height } ) {
    return (
        <Marketing image={ image }>
            <Content>
                <Title>{ title }</Title>
                <Description>{ desc }</Description>
                <Note>{ note }</Note>
            </Content>
        </Marketing>
    );
}

const Marketing = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: ${ p => p.height ? p.height : calc4k( 960.5 ) };
    padding: 0 ${ padding.side };
    background-image: url(${ p => p.image });
    background-size: cover;
    background-position: center;
    position: relative;
    
    &::before {
        content: '';
        background: ${ gradient.purple };
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.9;       
    }
`;

const Content = styled.div`
    position: relative;
    z-index: 1;
`;

const Title = styled.h2`
    font-size: ${ calc4k( 90 ) };
    margin-bottom: ${ calc4k( 80 ) };
    font-weight: 500;
`;

const Description = styled.p`
    font-size: ${ calc4k( 45 ) };
    margin-bottom: ${ calc4k( 60 ) };
`;

const Note = styled.div`
    font-size: ${ calc4k( 45 ) };
    color: ${ colors.gold };
`;